import styled from 'styled-components';
import { colors } from '@alixpartners/ui-components';
import { colorError } from 'styles/colors';
import { ApButtonSecondary } from '@alixpartners/ui-components';

export const ErrorLabel = styled.div`
	color: ${colorError};
	margin-top: 5px;
`;

export const Line = styled.div`
	border-top: 1px solid ${colors.grey3};
	width: 100%;
	margin: 30px 0 24px 0;
`;

export const StyledApButtonSecondary = styled(ApButtonSecondary)`
	float: right;
`;
